import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Row, Col, Button } from 'react-bootstrap';

import useReportContents from 'components/Common/ReportContents/Hooks/useReportContents';

import actions from './Actions';

import Table from './Table';
import Run from './Run';

export default function Index({ enterpriseId }) {
  const [show, setShow] = useState(false);

  const [reportContents, refresh] = useReportContents({ enterpriseId });

  const onClose = () => {
    setShow(false);
    refresh();
  };

  const onDelete = (id) => {
    actions.delete(id, () => {
      refresh();
    });
  };

  return (
    <div className="ibox-content mt20">
      <Row>
        <Col md={6}>
          <h2 className="block-title">
            Reports
          </h2>
        </Col>
        <Col md={6} className="text-right">
          <Button
            onClick={() => setShow(true)}
            bsStyle="primary"
          >
            Add Report
          </Button>
        </Col>
      </Row>

      <Table onDelete={onDelete} enterpriseId={enterpriseId} reportContents={reportContents} />

      {show && <Run enterpriseId={enterpriseId.toString()} onHide={onClose} />}
    </div>
  );
}

Index.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
};
